import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { Configuration } from './configurations.interfaces';

@Injectable({
  providedIn: 'root',
})

/**
 * Configuration REST calls
 */
export class ConfigurationsService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  /**
   * Install a configuration
   * @param configuration The configuration to be installed
   */
  installConfiguration(configuration: Configuration, auto: boolean) {
    const url =
      `${this.globals.apiRoot}/jwtconfigurations/${configuration.id}/install?auto=` +
      auto;
    return this.http.post<void>(url, null);
  }

  /**
   * Accept a configuration
   * @param configuration The configuration that is accepted
   */
  acceptConfiguration(configuration: Configuration) {
    const url = `${this.globals.apiRoot}/jwtconfigurations/${configuration.id}/accept`;
    return this.http.post<void>(url, null);
  }

  /**
   * Refuse a configuration
   * @param configuration The configuration that is refused
   */
  refuseConfiguration(configuration: Configuration) {
    const url = `${this.globals.apiRoot}/jwtconfigurations/${configuration.id}/refuse`;
    return this.http.post<void>(url, configuration);
  }

  /**
   * Delete a configuration
   * @param configuration The configuration that should be deleted
   */
  deleteConfiguration(configuration: Configuration) {
    const url = `${this.globals.apiRoot}/jwtconfigurations/${configuration.id}`;
    return this.http.delete<void>(url);
  }

  /**
   * get all the configurations of a device
   */
  getConfigurations(deviceId: number): Observable<Configuration[]> {
    return this.http.get<Configuration[]>(
      `${this.globals.apiRoot}/jwtdevices/${deviceId}/configurations`
    );
  }
}
